import React from 'react';

const Body = () => (
    <>
        <div className="aboutTopPad"></div>
        <h3>Our Mission</h3>
        <h4>
            <i>
                The JD Foundation aims to support charities working with disadvantaged young people
                in the UK. The JD Foundation works with a number of youth charity partners,
                including mental health and homeless charities. In addition to supporting youth
                charities, The JD Foundation is also delighted to be supporting Mountain Rescue
                England & Wales and Scottish Mountain Rescue.
            </i>
        </h4>
        <br />
        The JD Foundation is a registered charity (Charities Commission registered number: 1167090)
        founded by JD Sports Fashion Plc in October 2015.
        <br />
        <br />
        To find out more about The JD Foundation visit one of our social media pages
        <br />
        <br />
        <a
            className="social"
            href="https://twitter.com/JDFoundationUK"
            target="_blank"
            rel="noopener noreferrer"
        >
            <i className="twitter"></i>@JDFoundationUK
        </a>
        <a
            className="social"
            href="https://www.facebook.com/TheJDFoundation"
            target="_blank"
            rel="noopener noreferrer"
        >
            <i className="facebook"></i>@TheJDFoundation
        </a>
        <a
            className="social"
            href="https://www.instagram.com/thejdfoundation/"
            target="_blank"
            rel="noopener noreferrer"
        >
            <i className="instagram"></i>@thejdfoundation
        </a>
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/jd-foundation.jpg',
    body: Body,
};
